import { render, staticRenderFns } from "./NameInput.vue?vue&type=template&id=6c81be52&scoped=true&"
import script from "./NameInput.vue?vue&type=script&lang=ts&"
export * from "./NameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c81be52",
  null
  
)

export default component.exports